'use client';

import { ParcelTexture, type ParcelTextureSettings } from '@/components/ui/parcel-texture';

/** The vector plat-map lines behind the Recon hero. Tuned with the local texture gear. */
export const reconHeroTexture: ParcelTextureSettings = {
  mode: 'vector',
  variation: 'Gentle suburb',
  seed: 4,
  lineWeight: 1.3,
  zoom: 2.5,
  lotSize: 1.2,
  lotVariety: 0.9,
  edgeFade: 0.55,
  strength: 0.1,
  pressure: 0.7,
  overshoot: 7,
  wobble: 1.25,
};

/** Behind the dark "02 / Investigate" card. Starts from the hero's settings. */
export const reconInvestigateTexture: ParcelTextureSettings = { ...reconHeroTexture };

/** Behind the dark "See what verified experience looks like" card. Starts from the hero's settings. */
export const reconCtaTexture: ParcelTextureSettings = { ...reconHeroTexture };

/** Behind the home page's banner, in place of the photo. Starts from the Recon hero's settings. */
export const homeHeroTexture: ParcelTextureSettings = { ...reconHeroTexture, variation: 'Winding hills', lotVariety: 0.8 };

/** Behind the graphic side of the home page's three light product cards, in place of their dot pattern. */
export const homeCardTexture: ParcelTextureSettings = { ...reconHeroTexture, variation: 'Winding hills', lotSize: 1.4, strength: 0.3 };

/** Lines take the lighter action-blue tint on dark surfaces. */
export default function HeroTexture({ settings = reconHeroTexture, className = '' }: { settings?: ParcelTextureSettings; className?: string }) {
  return <ParcelTexture settings={settings} className={`text-blue-400 ${className}`} />;
}
